<template>
  <el-dialog
    width="838px"
    :visible="visible"
    :close-on-click-modal="false"
    :title="isDetail ? '设备详情' : id ? '修改设备' : '新增设备'"
    @close="handleCloseDialog"
    @closed="reset"
  >
    <el-form
      v-loading="dialogLoading"
      ref="paramsFormRef"
      :rules="paramsFormRules"
      :model="paramsForm"
      label-width="110px"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="orgId" label="所属机构">
            <el-select
              v-if="!isDetail"
              v-model="paramsForm.orgId"
              @change="getSysUniqueNoData"
              placeholder="请输入/选择"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in orgList"
                :key="item.orgId"
                :label="item.orgName"
                :value="item.orgId"
              ></el-option>
            </el-select>
            <span v-else>{{ detailForm.orgName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="deviceName" label="设备名称">
            <el-input
              v-if="!isDetail"
              v-model.trim="paramsForm.deviceName"
              :maxlength="20"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ detailForm.deviceName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="sysUqNo" label="系统业务标识">
            <el-input
              v-if="!isDetail"
              v-model.trim="paramsForm.sysUqNo"
              disabled
              placeholder="选择所属机构后自动生成"
            ></el-input>
            <span v-else>{{ detailForm.sysUqNo }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="deviceCategoryId" label="设备类型">
            <el-radio-group
              v-if="!isDetail"
              v-model="paramsForm.deviceCategoryId"
              @change="typeChange"
            >
              <el-col :lg="{ span: '4-8' }" v-for="item in deviceCategoryList" :key="item.id">
                <el-radio :label="item.id">
                  <Ellipsis :texts="item.categoryName" :length="14" />
                </el-radio>
              </el-col>
            </el-radio-group>
            <span v-else>{{ detailForm.deviceCategoryName }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <Common
        ref="commonLayout"
        :deviceTypeCode="deviceTypeCode"
        :orgId="paramsForm.orgId"
        :deviceCategoryId="paramsForm.deviceCategoryId"
        :id="id"
        :areaList="areaList"
        :sysNo="paramsForm.sysUqNo"
        :detailForm="detailForm"
        v-if="paramsForm.orgId && paramsForm.deviceCategoryId"
      />
    </el-form>
    <div slot="footer">
      <el-button @click="handleCloseDialog">取消</el-button>
      <el-button v-if="isDetail" type="primary" @click="handleEdit">修改</el-button>
      <el-button v-else type="primary" @click="handleSubmit" :loading="btnLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Ellipsis from '@/components/Ellipsis';
import newDeviceApi from 'api/home/device-mangement';
import deviceApi from '@/api/home/device.js';
import Common from './moudle/CommonLayout';
export default {
  components: { Common, Ellipsis },
  props: {
    // 机构列表
    orgList: {
      type: Array,
      require: true
    },
    areaList: {
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      isDetail: false,
      dialogLoading: false,
      btnLoading: false,
      deviceTypeCode: '',
      deviceCategoryList: [],
      id: '',
      paramsForm: {
        orgId: '',
        sysUqNo: '',
        deviceName: '',
        deviceCategoryId: ''
      },
      detailForm: {},
      deviceDetail: {}
    };
  },
  watch: {
    // 处理以往不具设备系列验证
    isDetail: {
      handler: function (newVal, oldVal) {
        if (oldVal && !newVal) {
          this.$refs.commonLayout.clearValidate();
        }
      }
    }
  },
  provide() {
    return {
      isDetail: () => {
        return this.isDetail;
      }
    };
  },
  computed: {
    paramsFormRules() {
      return {
        orgId: [{ required: !this.isDetail, message: '请选择所属机构', trigger: 'change' }],
        sysUqNo: [{ required: !this.isDetail, message: '请选择所属机构自动生成唯一标识' }],
        deviceName: [{ required: !this.isDetail, message: '请输入设备名称', trigger: 'blur' }],
        deviceCategoryId: [
          { required: !this.isDetail, message: '请选择设备类型', trigger: 'change' }
        ]
      };
    }
  },
  created() {
    // console.log(this.id);
  },
  methods: {
    init(id, isDetail) {
      this.visible = true;
      this.getDeviceCategoryListData();
      this.id = id || '';
      this.isDetail = isDetail || false;
      this.$nextTick(() => {
        this.$refs.paramsFormRef.clearValidate();
      });
      this.id && this.getDetail();
    },
    // 获取系统唯一标识
    getSysUniqueNoData(val) {
      // 编辑时不请求本身机构
      // console.log(val, this.deviceDetail.orgId);
      if (val === this.deviceDetail.orgId) {
        this.paramsForm.sysUqNo = this.deviceDetail.sysUqNo;
        return;
      }
      deviceApi.getSystemUniqueNo(val).then(res => {
        if (res.data.code === 200) {
          this.paramsForm.sysUqNo = res.data.data;
        }
      });
    },
    typeChange(typeId) {
      const deviceCategory = this.deviceCategoryList.find(item => item.id == typeId);
      this.deviceTypeCode = deviceCategory.categoryNo;
    },
    // 获取设备类型下拉列表
    getDeviceCategoryListData() {
      newDeviceApi.getDeviceTypeList().then(res => {
        if (res.data.code === 200) {
          this.deviceCategoryList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },

    // 获取设备详情
    getDetail() {
      // this.$refs.commonLayout.init();
      this.dialogLoading = true;
      newDeviceApi
        .getDeviceDetail({ id: this.id })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code === 200) {
            this.detailForm = data;
            this.deviceDetail.orgId = data.orgId;
            this.rewriteParamsForm(data);
            this.typeChange(data.deviceCategoryId);
          } else {
            // this.$message.error('获取设备详情失败，请重试');
            this.$emit('back');
          }
        })
        .finally(() => {
          this.$nextTick(() => {
            this.dialogLoading = false;
          });
        });
    },
    // 新增设备接口
    postNewDeviceData() {
      this.btnLoading = true;
      const data = {
        ...this.$refs.commonLayout.submit(),
        ...this.paramsForm
      };
      data.deviceCategoryName = this.deviceCategoryList.find(
        item => item.id == this.paramsForm.deviceCategoryId
      ).categoryName;
      newDeviceApi
        .addDevice(data)
        .then(res => {
          const {
            data: { code }
          } = res;
          if (code === 2016003) {
            this.$message.error('系统唯一标识重复，请重新输入');
          }
          if (code === 2016004) {
            this.$message.error('出厂编号重复，请重新输入');
          }
          if (code === 2016005) {
            this.$message.error('MN号重复，请重新输入');
          }
          if (code === 2016006) {
            this.$message.error('系统业务标识重复，请重新获取');
            this.getSysUniqueNoData(this.paramsForm.orgId);
          }
          if (code === 2016007) {
            this.$refs.commonLayout.getNoAgain();
          }
          // if (code === 2016008) {
          //   this.$message.error('视频通道重复，请重新获取');
          //  this.$refs.commonLayout.getChannelAgian()
          // }
          if (code !== 200) {
            return;
          }
          this.$message.success('新增设备成功');
          this.$emit('back', 200);
          this.visible = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 编辑设备接口
    postEditDeviceData() {
      this.btnLoading = true;
      const data = {
        id: this.id,
        ...this.$refs.commonLayout.submit(),
        ...this.paramsForm
      };
      data.deviceCategoryName = this.deviceCategoryList.find(
        item => item.id == this.paramsForm.deviceCategoryId
      ).categoryName;
      newDeviceApi
        .editDevice(data)
        .then(res => {
          // console.log(this.orgList);
          const {
            data: { data, code }
          } = res;
          if (code === 2016003) {
            this.$message.error('系统唯一标识重复，请重新输入');
          }
          if (code === 2016004) {
            this.$message.error('出厂编号重复，请重新输入');
          }
          if (code === 2016005) {
            this.$message.error('MN号重复，请重新输入');
          }
          if (code === 2016006) {
            this.$message.error('系统业务标识重复，请重新获取');
            this.getSysUniqueNoData(this.paramsForm.orgId);
          }
          if (code === 2016007) {
            this.$refs.commonLayout.getNoAgain();
          }
          // if (code === 2016008) {
          //   this.$message.error('视频通道重复，请重新获取');
          //  this.$refs.commonLayout.getChannelAgian()
          // }
          if (code !== 200) {
            return;
          }
          this.$message.success('修改设备成功');
          this.$emit('back', 233);
          this.visible = false;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 重置表单参数
    resetParamsForm() {
      this.$refs.paramsFormRef.resetFields();
    },
    reset() {
      if (this.paramsForm.orgId && this.paramsForm.deviceCategoryId) {
        this.$refs.commonLayout.reset();
      }
      this.btnLoading = false;
      this.dialogLoading = false;
      this.id = '';
      this.deviceTypeCode = '';
      this.detailForm = {};
      this.deviceDetail = {};
      this.resetParamsForm();
    },
    // 编辑时重写 paramsForm
    rewriteParamsForm(data) {
      for (const key in this.paramsForm) {
        this.paramsForm[key] = data[key];
      }
      this.$nextTick(() => {
        this.$refs.commonLayout.setData(data);
      });
    },
    // 点击取消
    handleCloseDialog() {
      this.visible = false;
      this.$emit('back');
    },
    handleEdit() {
      this.isDetail = false;
    },
    // 点击确定
    handleSubmit() {
      this.$refs.paramsFormRef.validate(valid => {
        let type = false;
        if (this.paramsForm.deviceCategoryId) {
          type = this.$refs.commonLayout.validate();
        }
        // 有id为编辑，无id为新增
        if (valid && type) {
          this.id ? this.postEditDeviceData() : this.postNewDeviceData();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-upload-list {
  width: 704px;
  display: flex;
  flex-wrap: wrap;
}
/deep/ .el-upload-list--picture .el-upload-list__item {
  width: 33.33%;
}
/deep/ .el-col-lg-4-8 {
  width: 20%;
  height: 30px;
  display: flex;
  align-items: center;
}
/deep/ .el-radio-group {
  width: 100%;
}
.device-category {
  // display: flex;
  // justify-content: space-between;
  margin-bottom: 12px;
  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
